import React, { useCallback } from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import { useEditForm } from '../../../modals/seller/form/hooks';
import InlineExclusiveForm from '../InlineExclusiveForm';
import OnSaleExclusiveForm from '../../../modals/seller/form/OnSaleExclusiveForm';
import {
  getSourceUrlInputName,
  getSourceFilesInputName,
} from '../../../modals/seller/redux/helpers';
import { DeviationSubmitFormData } from '../../../redux/types';

interface Props {
  deviation: PapiDeviation;
}

const EditExclusiveForm: React.FC<Props> = ({ deviation }) => {
  const formContext = useEditForm(deviation);
  const submitAdapter = useCallback(
    (data: DeviationSubmitFormData) => {
      const sourceFiles = data.editExclusive?.[getSourceFilesInputName(deviation)] || [];
      return data['editExclusive']
        ? {
            editExclusive: {
              source_url: data['editExclusive'][getSourceUrlInputName(deviation)],
              include_original: sourceFiles.filter(file => file.deviationId === 0).length > 0,
            },
          }
        : {};
    },
    [deviation]
  );
  return (
    <InlineExclusiveForm
      formName="editExclusive"
      formContext={formContext}
      submitAdapter={submitAdapter}
    >
      <OnSaleExclusiveForm deviation={deviation} />
    </InlineExclusiveForm>
  );
};
EditExclusiveForm.displayName = 'EditExclusiveForm';

export default EditExclusiveForm;
